import { Box, Radio, TextField, Tooltip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useStyles } from "./styles";
import { NoResponse } from "../../../../../../../../../../components/errors/noResponse";
import { forwardRef, memo, Ref, useImperativeHandle, useState } from "react";
import { useCatalogStoreModule } from "../../context";
import { onChange } from "../../../../../../../../../../utils/types";
import { InputModalRef } from "./types";



const ModalProvider = ({ providerId }: { providerId?: number }, ref: Ref<InputModalRef>) => {

    const { t } = useTranslation();
    const styles = useStyles();
    const { providers } = useCatalogStoreModule();
    const [searchValue, setSearchValue] = useState<string>('');
    const filteredProviders = providers?.filter(provider => provider.label.toLowerCase().includes(searchValue.toLowerCase()));
    const [providerSelected, setProviderSelected] = useState<number | null>(providerId ?? null);

    const handleChangeSearchValue: onChange = (e, id): void => {
        const { name, value } = e?.target
        setSearchValue(value);
    }

    const handleChangeProvider = (event: React.ChangeEvent<HTMLInputElement>) => {
        setProviderSelected(Number(event.target.value));
    };

    useImperativeHandle(ref, () => ({
        getProviderId: () => providerSelected ?? undefined,
    }));


    return (
        <Box>
            <Box sx={styles.containerSearchInput} >
                <TextField
                    label={t('catalog.inputs.searchProvider')}
                    variant="outlined"
                    value={searchValue}
                    onChange={handleChangeSearchValue}
                    sx={styles.wdth}
                />
            </Box>
            < Box sx={styles.containerProvider} >
                {!!filteredProviders && filteredProviders.map(provider => (
                    <Box sx={styles.containerRadio} key={provider.id} >
                        <Radio
                            name="delete"
                            value={provider.value}
                            checked={providerSelected === provider.value}
                            onChange={handleChangeProvider}
                        />
                        <Tooltip title={provider.label}>
                            <Typography>{t('catalog.provider')} <span> {provider.label} </span></Typography >
                        </Tooltip>
                    </Box>
                ))}
                {
                    !filteredProviders?.length && (
                        <NoResponse label={t('catalog.noProvider')} />
                    )
                }
            </Box>
        </Box>

    );
};


const ModalProviderComponent = memo(forwardRef(ModalProvider));
export default ModalProviderComponent;